export const SAVE = 'stepAppsureBankDetails.SAVE';
export const VALUE_CHANGED = 'stepAppsureBankDetails.VALUE_CHANGED';
export const LOAD = 'stepAppsureBankDetails.VALUE_LOAD';
export const NEXT = 'stepAppsureBankDetails.NEXT';
export const RESET = 'stepAppsureBankDetails.RESET';
export const RESET_REGISTER_GST_STATE = 'stepAppsureBankDetails.RESET_REGISTER_GST_STATE';
export const CLOSE_BSB_NOTICE = 'stepAppsureBankDetails.CLOSE_BSB_NOTICE';
export const RESET_TUGO_BANK_FIELDS = 'stepAppsureBankDetails.RESET_TUGO_BANK_FIELDS';
export const RESET_ADDRESS = 'stepAppsureBankDetails.RESET_ADDRESS';

// Dynamic Payment Form
export const FNOL_GET_PAYMENT_CODE_TYPES = 'stepAppsureBankDetails.FNOL_GET_PAYMENT_CODE_TYPES';
export const FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS = 'stepAppsureBankDetails.FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS';
export const FNOL_GET_PAYMENT_FORM_FIELDS = 'stepAppsureBankDetails.FNOL_GET_PAYMENT_FORM_FIELDS';
export const FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS = 'stepAppsureBankDetails.FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS';
export const FNOL_SET_DYNAMIC_FIELD_VALUE = 'stepAppsureBankDetails.FNOL_SET_DYNAMIC_FIELD_VALUE';
export const FNOL_RESET_DYNAMIC_FORM = 'stepAppsureBankDetails.FNOL_RESET_DYNAMIC_FORM';
export const FNOL_SET_SELECTED_CODE_TYPE = 'stepAppsureBankDetails.FNOL_SET_SELECTED_CODE_TYPE';
export const FNOL_VALIDATE_CODE_FIELD = 'stepAppsureBankDetails.FNOL_VALIDATE_CODE_FIELD';
export const FNOL_VALIDATE_TRANSIT_NUMBER_DYNAMIC = 'stepAppsureBankDetails.FNOL_VALIDATE_TRANSIT_NUMBER_DYNAMIC';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/constants.js